var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_80501",
    "data-name": "Group 80501",
    transform: "translate(14552 -2974)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19836",
    "data-name": "Rectangle 19836",
    width: 24,
    height: 24,
    transform: "translate(-14552 2974)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chat",
    transform: "translate(-14552.857 2973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111349",
    "data-name": "Path 111349",
    d: "M15.155,17.887a.745.745,0,0,1-.789-.789,3.594,3.594,0,0,1,1.42-2.524c.473-.473.946-.946.946-1.42a1.577,1.577,0,1,0-3.155,0,.789.789,0,1,1-1.577,0,3.155,3.155,0,0,1,6.31,0,3.594,3.594,0,0,1-1.42,2.524c-.473.473-.946.946-.946,1.42A.745.745,0,0,1,15.155,17.887Z",
    transform: "translate(-1.893 -1.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1072",
    "data-name": "Ellipse 1072",
    cx: 0.789,
    cy: 0.789,
    r: 0.789,
    transform: "translate(12.473 17.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111350",
    "data-name": "Path 111350",
    d: "M4.113,23.387A.914.914,0,0,1,3.8,22.6l.71-4.022a10.143,10.143,0,0,1,3.47-13.96,10.323,10.323,0,0,1,14.039,3.47,10.252,10.252,0,0,1-3.47,14.039A10.11,10.11,0,0,1,8.214,22.2L4.98,23.545a1.034,1.034,0,0,1-.868-.158Zm4.1-2.839a.6.6,0,0,1,.394.158A8.687,8.687,0,1,0,5.927,8.639a8.774,8.774,0,0,0,0,9.386.693.693,0,0,1,.079.552l-.473,2.918,2.287-.946Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.92c4fcfc340db8bebd0a5126dd33ad6e.svg";
export { ForwardRef as ReactComponent };